import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Functions from '@client/style/Functions';
import FilterStore from '@client/modules/ListModules/FilterStore';
import { loadExperiences } from '@client/core/utils/EntityLoader';
import CollectionInfoStore from '../ContentTypeStore';
import { DateUtils } from '@client/core/utils/DateUtils';
import FilteredListContent from './FilteredListContent';
import FilteredListToolbar from './FilteredListToolbar';

const Container = styled.div<{ bgColor?: string }>`
	width: 100%;

	background-color: ${props => props.bgColor};

	&:has(+ .BreakerModule) {
		padding-bottom: var(--breaker-total);
	}
`;

const ListsContainer = styled.div`
	padding: 0px var(--gridMargin);
	padding-bottom: 100px;
	/* max-width: 100%; */
	width: 100%;
`;

export default function FilteredListModule({
	data,
}: {
	data: {
		addedContent?: Array<any>;
		useLocationFilter: boolean;
		useTagFilter: boolean;
		useDateFilter: boolean;
		contentTypes: { id: string; name: string }[];
		backgroundColorLink: any;
		detailedThumbnail: boolean;
		detailedThumbnailWithTimestamp: boolean;
		noMatchesText: string;
	};
}) {
	const [contents, setContents] = useState<any[]>([]);

	// Filtering store use
	const locationFilter = FilterStore.use(state => state.selectedLocationFilters);
	const tagFilter = FilterStore.use(state => state.selectedTagFilters);
	const dateFilter = FilterStore.use(state => state.selectedDateFilters);

	const selectedCollectionInfo = CollectionInfoStore.use(state => state.activeInfo);

	useEffect(() => {
		if (
			data.contentTypes &&
			(data.contentTypes[0]?.name.toLowerCase().includes('musik') || data.contentTypes[0]?.name === 'Snakke') &&
			data.addedContent
		) {
			setContents(sortContent(data.addedContent));
		} else {
			getNewData();
		}
	}, [locationFilter, tagFilter, selectedCollectionInfo, dateFilter]);

	const getNewData = async () => {
		// console.log('getNewData');
		let content = [];
		content = await loadExperiencePages();
		setContents(content);
	};

	async function loadExperiencePages() {
		const contentTypeString = data.contentTypes?.map(contentType => contentType.id);

		const contentPages = await loadExperiences(undefined, contentTypeString, locationFilter, tagFilter);

		if (contentPages.data?.results) {
			return contentPages.data.results;
		}
		return [];
	}

	const sortContent = (input: any[]) => {
		const result = input.filter(e => {
			if (data.contentTypes[0]?.name !== e.contentType?.name) return false;
			if (locationFilter.length > 0 && !locationFilter.includes(e.location?.id)) return false;
			if (tagFilter.length > 0 && !tagFilter.includes(e.tags?.id)) return false;
			if (dateFilter) {
				if (e.startTime === null) return false;
				if (!DateUtils.isOnSameSmukDay(new Date(e.startTime), new Date(dateFilter))) return false;
			}

			return true;
		});

		return result.sort((a, b) => {
			return a.title.localeCompare(b.title);
		});
	};

	return (
		<Container
			bgColor={data.backgroundColorLink && Functions.hexFromRGB(data.backgroundColorLink?.color)}
			className='colorWrapperAnimatedModule'
		>
			<FilteredListToolbar
				contentTypes={data.contentTypes}
				addedContent={data.addedContent}
				useDateFilter={data.useDateFilter}
				useTagFilter={data.useTagFilter}
				useLocationFilter={data.useLocationFilter}
				backgroundColorLink={data.backgroundColorLink}
			/>
			<ListsContainer>
				<FilteredListContent
					contents={contents}
					detailedThumbnail={data.detailedThumbnail}
					detailedThumbnailWithTimestamp={data.detailedThumbnailWithTimestamp}
					noMatchesText={data.noMatchesText}
					backgroundColorLink={data.backgroundColorLink}
				/>
			</ListsContainer>
		</Container>
	);
}
